/*
 * The partners component holds logic to display partner companies.
 */

import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '@components/base/base.component';
import { BaseService } from '@services/base/base.service';
import { PackagesService } from '@services/packages/packages.service';

@Component({
  selector: 'app-component-packages',
  templateUrl: 'packages.component.html',
  styleUrls: ['packages.component.less']
})
export class PackagesComponent extends BaseComponent implements OnInit {
  // declaration of fields
  public innerWidth: number;
  public numberCells = 4;

  constructor(
    public baseService: BaseService,
    private packagesService: PackagesService
  ) {
    super(baseService);
  }

  ngOnInit() {
    this.list = this.packagesService.get();

    if (this.isBrowser) {
      this.innerWidth = window.innerWidth;
      if (this.innerWidth <= 998 && this.innerWidth >= 768) {
        this.numberCells = 3;
      } else if (this.innerWidth <= 768) {
        this.numberCells = 1;
      }
    }
  }
}
